import {httpPost} from "../../../api/http-functions";
import {searchOrgUnitMachines} from "../../../api/machine-functions";
import {withLazyDynamicTable} from "../../ui/hoc/LazyDynamicTable";
import {useTranslation} from "react-i18next";
import React, {Fragment, useState} from "react";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import {TableLoadingRow} from "../../ui/table/TableLoadingRow";
import {TableEmptyRow} from "../../ui/table/TableEmptyRow";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {MachineContactsManagementAction} from "../../machines/shared/machine-actions/MachineContactsManagementAction";
import {MachineTagsManagementAction} from "../../machines/shared/machine-actions/MachineTagsManagementAction";
import {MachineRenameAction} from "../../machines/shared/machine-actions/MachineRenameAction";
import {MachineResetAction} from "../../machines/shared/machine-actions/MachineResetAction";
import {ActionsMenu} from "../../ui/ActionsMenu";
import {makeStyles} from "@material-ui/core/styles";
import MachineAvatar from "../../machines/shared/MachineAvatar";
import {Typography} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import {ChipBackgroundColors, ChipTextColors} from "../../../layout/_constants";
import {MoveMachineAction} from "../../machines/shared/machine-actions/MoveMachineAction";
import {convertDateStringToLocaleJsonDate} from "../../../utils/function-util";

export const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    actionColumn: {
        maxWidth: 100,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    },
    spinner: {
        position: 'absolute',
        left: '50%'
    }
}));

const MachineDataRow = (props: any) => {
    const {friendlyName, email, tags, isActive, expirationDate, isExpired, actions, label,version} = props;
    const {t} = useTranslation();

    return (
        <TableRow>
            <TableCell component="th" scope="row"> <MachineAvatar/> </TableCell>
            <TableCell>
                <Typography variant="body1">{friendlyName}</Typography>
                <Typography variant="body2"
                            color={'textPrimary'}>{email}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="body1">{(version && !label) ? t('Machine.UCVersion.Unknown') : label}</Typography>
                <Typography variant="body2" color={'textPrimary'}>{version}</Typography>
            </TableCell>
            <TableCell>
                {
                    isActive ?
                        isExpired ?
                            <Chip color='primary' style={{backgroundColor: ChipBackgroundColors.Expired}}
                                  label={t('Machine.SubscriptionStatus.Expired')}/>
                            : <Chip color='primary' style={{backgroundColor: ChipBackgroundColors.Active, color: ChipTextColors.Active}}
                                    label={t('Machine.SubscriptionStatus.Active')}/>
                        : <Chip color='primary' style={{backgroundColor: ChipBackgroundColors.NonActive, color: ChipTextColors.NonActive}}
                                label={t('Machine.SubscriptionStatus.NonActive')}/>
                }
            </TableCell>
            <TableCell>
                 <span>{convertDateStringToLocaleJsonDate(expirationDate)}</span>
            </TableCell>
            <TableCell>
                {tags.map((tag: any) => <Chip color='primary' key={tag.key} label={tag.key} title={tag.value}
                                            style={{margin: '2px'}}/>)}
            </TableCell>
            <TableCell align="center">
                {actions}
            </TableCell>
        </TableRow>
    );
};


const _Machines = ({
                       loading,
                       data: machines,
                       onDataItemUpdated,
                       handleChange,
                       ...props
                   }: any) => {
    const {t} = useTranslation();
    return (
        <Fragment>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.MachineName')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.UCVersion.Title')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.SubscriptionStatus.Title')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.ExpirationDate')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Machine.Tags')}
                        </label>
                    </TableCell>
                    <TableCell style={{width: "50px"}} align="center">
                        <label>
                            {t(`Machine.Actions.Title`)}
                        </label>
                    </TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    loading ?
                        <TableLoadingRow /> :
                        machines.length === 0 ?
                            <TableEmptyRow messageKey={'Machine.NoMachines'}/> :
                            machines.map((m: any) => <MachineDataRow
                                key={m.id}
                                {...m}
                                {...props}
                                actions={<ActionsMenu>
                                    {(onClose: any) => <>
                                        <MachineContactsManagementAction {...m} {...props}/>
                                        <MachineTagsManagementAction {...m} {...props}/>
                                        <MachineRenameAction {...m} {...props}
                                                             onRenamed={(friendlyName: any) => {
                                                                 onDataItemUpdated({
                                                                     ...m,
                                                                     friendlyName
                                                                 }, (e: any) => e.id === m.id);
                                                                 onClose();
                                                             }}
                                                             onCancel={onClose}
                                        />
                                        <MachineResetAction {...m} {...props} onActionCompleted={onClose}/>
                                        <MoveMachineAction organizationId={props.organizationId} machine={m}
                                                           onMoved={handleChange}
                                                           onActionCompleted={onClose}/>
                                    </>}
                                </ActionsMenu>}

                            />)
                }
            </TableBody>
        </Fragment>
    );
}

export const Machines = (props: any) => {
    const {organizationUnitId} = props;
    const [refresh, setRefresh] = useState(0);
    const query = ({
                       page,
                       size,
                       filter
                   }: any) => {
        const search = searchOrgUnitMachines(httpPost);
        return search({organizationUnitId, size, page, filter});
    };

    const handleChange = () => {
        setRefresh(r => r + 1);
    }
    return withLazyDynamicTable(_Machines, query, ['organizationUnitId'])({...props, refresh, handleChange});
};
